<template>
  <v-container class="content-wrapper" id="equipment-tab">
    <v-row class="mt-10">
      <v-spacer></v-spacer>
      <v-col v-if="services != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px;">
            <div class="dashboard-tiles">
              <div class="header">
                Onboarded <br />
                Services
              </div>
              <div class="counter">{{ services }}</div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
      <v-col v-if="providers != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px;">
            <div class="dashboard-tiles">
              <div class="header">
                Onboarded <br />
                Providers
              </div>
              <div class="counter">{{ providers }}</div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
      <v-col v-if="ordersCompleted != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px;">
            <div class="dashboard-tiles">
              <div class="header">
                Orders <br />
                Completed
              </div>
              <div class="counter">{{ ordersCompleted }}</div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
      <v-col v-if="ordersPending != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px;">
            <div class="dashboard-tiles">
              <div class="header">
                Orders <br />
                Pending
              </div>
              <div class="counter">{{ ordersPending }}</div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-row class="mt-10">
      <v-col v-if="!loadingChart1" cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
        <v-card elevation="3" style="border-radius: 24px;">
          <v-scale-transition>
            <div class="dashboard-tiles">
              <div class="chart-title mb-5">
                Distribution of Resources <br />
                Categories
              </div>
              <vue-apex-charts
                :height="height"
                type="donut"
                :options="chartOptions1"
                :series="series1"
              ></vue-apex-charts>
            </div>
          </v-scale-transition>
        </v-card>
      </v-col>
      <v-col v-if="!loadingChart2" cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
        <v-card elevation="3" style="border-radius: 24px;">
          <v-scale-transition>
            <div class="dashboard-tiles">
              <div class="chart-title mb-5">
                Distribution of Resources <br />
                Scientific Domains
              </div>
              <vue-apex-charts
                :height="height"
                type="donut"
                :options="chartOptions2"
                :series="series2"
              ></vue-apex-charts>
            </div>
          </v-scale-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'DashboardRepresentative',
  components: { VueApexCharts },
  mixins: [util],
  data: () => ({
    services: null,
    providers: null,
    ordersCompleted: null,
    ordersPending: null,
    loadingChart1: true,
    series1: [],
    chartOptions1: {
      labels: [],
      legend: {
        position: 'right',
      },
      responsive: [
        {
          breakpoint: 600,
          options: {
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
    loadingChart2: true,
    series2: [],
    chartOptions2: {
      labels: [],
      legend: {
        position: 'right',
      },
      responsive: [
        {
          breakpoint: 600,
          options: {
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }),

  created() {
    let firstTime = sessionStorage.getItem('firstTime');
    if (firstTime === 'true') {
      const marketplaceServicesViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Services';
      let routePath = '';
      routePath = '/marketplace/services';
      this.$router.push({
        path: routePath,
        query: { selectedCatalogue, marketplaceServicesViewAll },
      });
      return;
    }

    this.axios.get('/api/v1/resources/count').then(res => (this.services = res.data));
    this.axios.get('/api/v1/providers/count').then(res => (this.providers = res.data));
    this.axios
      .get('/api/v1/orders/count-orders-completed')
      .then(res => (this.ordersCompleted = res.data));
    this.axios
      .get('/api/v1/orders/count-orders-pending')
      .then(res => (this.ordersPending = res.data));
    this.axios.get('/api/v1/resources/group-by-category-for-institution').then(res => {
      this.series1 = res.data.map(sr => sr[1]);
      this.chartOptions1.labels.push(...res.data.map(sr => sr[0]));
      this.loadingChart1 = false;
    });
    this.axios.get('/api/v1/resources/group-by-scientific-for-institution').then(res => {
      this.series2 = res.data.map(sr => sr[1]);
      this.chartOptions2.labels.push(...res.data.map(sr => sr[0]));
      this.loadingChart2 = false;
    });
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 800;
        case 'sm':
          return 800;
        case 'md':
          return 300;
        case 'lg':
          return 300;
        case 'xl':
          return 300;
        default:
          return 300;
      }
    },
  },
};
</script>
